import { render, staticRenderFns } from "./insuranceOrder.vue?vue&type=template&id=a273aec8&scoped=true&"
import script from "./insuranceOrder.vue?vue&type=script&lang=js&"
export * from "./insuranceOrder.vue?vue&type=script&lang=js&"
import style0 from "./insuranceOrder.vue?vue&type=style&index=0&id=a273aec8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a273aec8",
  null
  
)

export default component.exports